import { render, staticRenderFns } from "./radish-list.vue?vue&type=template&id=1985c726&"
import script from "./radish-list.vue?vue&type=script&lang=js&"
export * from "./radish-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports